export default {
  en: {
    // CreateUpdateFeedBack.vue
    edit: 'Edit',
    create: 'Create',
    createCase: 'Create Case',
    emailPreviewSupportOnly: 'Email Preview (Support Only)',
    originalEmail: 'Original Email',
    originalEmailPreview: 'Original Email Preview',
    originalEmailAlertLine1:
      'This preview shows the original email QSRSoft received.',
    originalEmailAlertLine2:
      'Updates will not affect this preview or the original email.',
    duplicateEmailsCount: 'Duplicate Emails ({count}):',
    duplicateEmailN: 'Duplicate Email {n}',
    duplicateEmailNPreview: 'Duplicate Email {n} Preview',
    duplicateEmailAlertLine1: 'This is a duplicate email ({n} of {count}).',
    duplicateEmailAlertLine2:
      'Updates to the form will not affect this preview or the original email.',
    internalHelpDeskForm: 'Internal Help Desk form',
    cancel: 'Cancel',
    update: 'Update',
    feedbackUpdated: 'Feedback Updated',
    feedbackCreated: 'Feedback Created',
    errorSavingFeedback: 'Error Saving Feedback',
    caseDetails: 'Case Details',
    createdFrom: 'Created From',
    store: 'Store',
    type: 'Type',
    complaint: 'Complaint',
    praise: 'Praise',
    inquiry: 'Inquiry',
    caseOrigin: 'Case Origin',
    incident: 'Incident',
    caseNumber: 'Case Number',
    created: 'Created',
    issueCategory: 'Issue Category',
    issueReason: 'Issue Reason',
    issueSubcode: 'Issue Subcode',
    globalPerformanceMatrix: 'Global Performance Matrix',
    yes: 'Yes',
    no: 'No',
    status: 'Status',
    open: 'Open',
    closed: 'Closed',
    recoveryRequired: 'Recovery Required',
    nextSteps: 'Next Steps',
    recoveryForm: 'Recovery Form',
    customerDetails: 'Customer Details',
    customerName: 'Customer Name',
    customerEmail: 'Customer Email',
    customerPhone: 'Customer Phone',
    location: 'Location',
    locationAddress: 'Location Address',
    orderPoint: 'Order Point',
    pickupPoint: 'Pickup Point',
    letterSent: 'Letter Sent',
    customerComments: 'Customer Comments',
    resolution: 'Resolution',
    details: 'Details',
  },
  es: {
    // CreateUpdateFeedBack.vue
    edit: 'Editar',
    create: 'Crear',
    createCase: 'Crear Caso',
    emailPreviewSupportOnly: 'Vista Previa del Correo (Solo Soporte)',
    originalEmail: 'Correo Original',
    originalEmailPreview: 'Vista Previa del Correo Original',
    originalEmailAlertLine1:
      'Esta vista previa muestra el correo original que recibió QSRSoft.',
    originalEmailAlertLine2:
      'Las actualizaciones no afectarán esta vista previa ni el correo original.',
    duplicateEmailsCount: 'Correos Duplicados ({count}):',
    duplicateEmailN: 'Correo Duplicado {n}',
    duplicateEmailNPreview: 'Vista Previa del Correo Duplicado {n}',
    duplicateEmailAlertLine1:
      'Este es un correo duplicado ({n} de {count}).',
    duplicateEmailAlertLine2:
      'Las actualizaciones al formulario no afectarán esta vista previa ni el correo original.',
    internalHelpDeskForm: 'Formulario del Servicio de Asistencia Interno',
    cancel: 'Cancelar',
    update: 'Actualizar',
    feedbackUpdated: 'Comentario Actualizado',
    feedbackCreated: 'Comentario Creado',
    errorSavingFeedback: 'Error al Guardar el Comentario',
    caseDetails: 'Detalles del Caso',
    createdFrom: 'Creado Desde',
    store: 'Tienda',
    type: 'Tipo',
    complaint: 'Queja',
    praise: 'Elogio',
    inquiry: 'Consulta',
    caseOrigin: 'Origen del Caso',
    incident: 'Incidente',
    caseNumber: 'Número de Caso',
    created: 'Creado',
    issueCategory: 'Categoría del Problema',
    issueReason: 'Motivo del Problema',
    issueSubcode: 'Subcódigo del Problema',
    globalPerformanceMatrix: 'Matriz de Desempeño Global',
    yes: 'Sí',
    no: 'No',
    status: 'Estado',
    open: 'Abierto',
    closed: 'Cerrado',
    recoveryRequired: 'Recuperación Requerida',
    nextSteps: 'Próximos Pasos',
    recoveryForm: 'Formulario de Recuperación',
    customerDetails: 'Detalles del Cliente',
    customerName: 'Nombre del Cliente',
    customerEmail: 'Correo del Cliente',
    customerPhone: 'Teléfono del Cliente',
    location: 'Ubicación',
    locationAddress: 'Dirección de la Ubicación',
    orderPoint: 'Punto de Pedido',
    pickupPoint: 'Punto de Entrega',
    letterSent: 'Carta Enviada',
    customerComments: 'Comentarios del Cliente',
    resolution: 'Resolución',
    details: 'Detalles',
  },
  fr: {
    // CreateUpdateFeedBack.vue
    edit: 'Modifier',
    create: 'Créer',
    createCase: 'Créer un cas',
    emailPreviewSupportOnly: "Aperçu de l'e-mail (support uniquement)",
    originalEmail: 'E-mail original',
    originalEmailPreview: "Aperçu de l'e-mail original",
    originalEmailAlertLine1:
      "Cet aperçu montre l'e-mail original reçu par QSRSoft.",
    originalEmailAlertLine2:
      "Les mises à jour n'affecteront pas cet aperçu ni l'e-mail original.",
    duplicateEmailsCount: 'E-mails en double ({count}) :',
    duplicateEmailN: 'E-mail en double {n}',
    duplicateEmailNPreview: "Aperçu de l'e-mail en double {n}",
    duplicateEmailAlertLine1:
      'Ceci est un e-mail en double ({n} sur {count}).',
    duplicateEmailAlertLine2:
      "Les mises à jour du formulaire n'affecteront pas cet aperçu ni l'e-mail original.",
    internalHelpDeskForm: "Formulaire du service d'assistance interne",
    cancel: 'Annuler',
    update: 'Mettre à jour',
    feedbackUpdated: 'Commentaire mis à jour',
    feedbackCreated: 'Commentaire créé',
    errorSavingFeedback: "Erreur lors de l'enregistrement du commentaire",
    caseDetails: 'Détails du cas',
    createdFrom: 'Créé depuis',
    store: 'Magasin',
    type: 'Type',
    complaint: 'Plainte',
    praise: 'Éloge',
    inquiry: 'Demande',
    caseOrigin: 'Origine du cas',
    incident: 'Incident',
    caseNumber: 'Numéro de cas',
    created: 'Créé',
    issueCategory: 'Catégorie du problème',
    issueReason: 'Motif du problème',
    issueSubcode: 'Sous-code du problème',
    globalPerformanceMatrix: 'Matrice de performance globale',
    yes: 'Oui',
    no: 'Non',
    status: 'Statut',
    open: 'Ouvert',
    closed: 'Fermé',
    recoveryRequired: 'Récupération requise',
    nextSteps: 'Prochaines étapes',
    recoveryForm: 'Formulaire de récupération',
    customerDetails: 'Détails du client',
    customerName: 'Nom du client',
    customerEmail: 'E-mail du client',
    customerPhone: 'Téléphone du client',
    location: 'Emplacement',
    locationAddress: "Adresse de l'emplacement",
    orderPoint: 'Point de commande',
    pickupPoint: 'Point de retrait',
    letterSent: 'Lettre envoyée',
    customerComments: 'Commentaires du client',
    resolution: 'Résolution',
    details: 'Détails',
  },
  'fr-ca': {
    // CreateUpdateFeedBack.vue
    edit: 'Modifier',
    create: 'Créer',
    createCase: 'Créer un cas',
    emailPreviewSupportOnly: 'Aperçu du courriel (soutien seulement)',
    originalEmail: 'Courriel original',
    originalEmailPreview: 'Aperçu du courriel original',
    originalEmailAlertLine1:
      'Cet aperçu montre le courriel original reçu par QSRSoft.',
    originalEmailAlertLine2:
      "Les mises à jour n'affecteront pas cet aperçu ni le courriel original.",
    duplicateEmailsCount: 'Courriels en double ({count}) :',
    duplicateEmailN: 'Courriel en double {n}',
    duplicateEmailNPreview: 'Aperçu du courriel en double {n}',
    duplicateEmailAlertLine1:
      'Ceci est un courriel en double ({n} sur {count}).',
    duplicateEmailAlertLine2:
      "Les mises à jour du formulaire n'affecteront pas cet aperçu ni le courriel original.",
    internalHelpDeskForm: "Formulaire du centre d'assistance interne",
    cancel: 'Annuler',
    update: 'Mettre à jour',
    feedbackUpdated: 'Commentaire mis à jour',
    feedbackCreated: 'Commentaire créé',
    errorSavingFeedback: "Erreur lors de l'enregistrement du commentaire",
    caseDetails: 'Détails du cas',
    createdFrom: 'Créé depuis',
    store: 'Magasin',
    type: 'Type',
    complaint: 'Plainte',
    praise: 'Éloge',
    inquiry: 'Demande',
    caseOrigin: 'Origine du cas',
    incident: 'Incident',
    caseNumber: 'Numéro de cas',
    created: 'Créé',
    issueCategory: 'Catégorie du problème',
    issueReason: 'Motif du problème',
    issueSubcode: 'Sous-code du problème',
    globalPerformanceMatrix: 'Matrice de performance globale',
    yes: 'Oui',
    no: 'Non',
    status: 'Statut',
    open: 'Ouvert',
    closed: 'Fermé',
    recoveryRequired: 'Récupération requise',
    nextSteps: 'Prochaines étapes',
    recoveryForm: 'Formulaire de récupération',
    customerDetails: 'Détails du client',
    customerName: 'Nom du client',
    customerEmail: 'Courriel du client',
    customerPhone: 'Téléphone du client',
    location: 'Emplacement',
    locationAddress: "Adresse de l'emplacement",
    orderPoint: 'Point de commande',
    pickupPoint: 'Point de cueillette',
    letterSent: 'Lettre envoyée',
    customerComments: 'Commentaires du client',
    resolution: 'Résolution',
    details: 'Détails',
  },
};
